import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Store, Trophy, MapPin } from 'lucide-react';
import { StatCard, WidgetPanel } from './DashboardShared';
import { branchesOf, salesOf } from '../../../data/store';

export const BranchesModule = ({ org }) => {
  const metrics = useMemo(() => {
    const branches = branchesOf(org.id);
    const sales = salesOf(org.id);

    const branchSales = {};
    branches.forEach(b => {
      branchSales[b.id] = { name: b.name, revenue: 0, bills: 0, id: b.id };
    });

    sales.forEach(s => {
      if (s.branchId && branchSales[s.branchId]) {
        branchSales[s.branchId].revenue += s.total;
        branchSales[s.branchId].bills += 1;
      }
    });

    const leaderboard = Object.values(branchSales)
      .sort((a,b) => b.revenue - a.revenue);

    const topBranch = leaderboard.length > 0 ? leaderboard[0].name : 'N/A';
    const maxRevenue = leaderboard.length > 0 ? leaderboard[0].revenue : 0;
    
    return { totalBranches: branches.length, topBranch, leaderboard, maxRevenue };
  }, [org.id]);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.15em] text-[#0d0d0d] border-b border-slate-100 pb-3 mt-4">
        <Store size={16} className="text-[var(--theme-primary)]" />
        Multi-Branch
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Store} label="Total Branches" value={metrics.totalBranches} iconColor="#14b8a6" />
        <StatCard icon={Trophy} label="Top Branch" value={<span className="truncate max-w-[150px] inline-block">{metrics.topBranch}</span>} iconColor="#f59e0b" />
      </div>

      <div className="grid grid-cols-1 gap-6">
        <WidgetPanel title="Revenue Leaderboard">
           <ul className="divide-y divide-slate-100">
              {metrics.leaderboard.length === 0 && <li className="py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-slate-300">No data</li>}
              {metrics.leaderboard.map((b, idx) => {
                 const pct = metrics.maxRevenue > 0 ? (b.revenue / metrics.maxRevenue) * 100 : 0;
                 return (
                  <li key={idx} className="py-4 flex flex-col gap-2">
                    <div className="flex justify-between items-center text-xs">
                      <div className="flex items-center gap-3">
                         <span className={`w-8 h-8 rounded-xl flex items-center justify-center text-[10px] font-bold ${idx === 0 ? 'bg-amber-100 text-amber-600' : 'bg-slate-50 text-slate-500 border border-slate-100'}`}>#{idx + 1}</span>
                         <span className="font-bold text-slate-700 truncate">{b.name}</span>
                      </div>
                      <span className="font-bold text-slate-800">₹{b.revenue.toFixed(2)}</span>
                    </div>
                    <div className="w-full bg-slate-50 rounded-full h-2 overflow-hidden ml-11" style={{ width: 'calc(100% - 44px)' }}>
                      <div className="h-full rounded-full transition-all duration-1000" style={{ width: `${pct}%`, backgroundColor: idx === 0 ? '#f59e0b' : '#3b82f6' }}></div>
                    </div>
                  </li>
                 );
              })}
           </ul>
        </WidgetPanel>
      </div>
    </div>
  );
};

BranchesModule.propTypes = {
  org: PropTypes.object.isRequired,
};
